export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/smashingmag-f6081752e01796ee9e012333bb513ee9.png";